import React from 'react';
import { Box, Grid, Typography, Stack } from '@mui/material';
import { IoCalendarOutline } from 'react-icons/io5';
import moment from 'moment-timezone';

interface TimezoneCardProps {
    date: Date;
    timezone: string;
    bgcolor: string;
}

const TimeCards: React.FC<TimezoneCardProps> = ({ date, timezone, bgcolor }) =>
{
	const formattedDate = timezone
		? moment(date).tz(timezone)
			.format('MMMM D, YYYY')
		: '';
	const formattedTime = timezone
		? moment(date).tz(timezone)
			.format('hh : mm A')
		: '';
	const timezoneName = timezone
		? moment.tz(timezone).zoneAbbr()
		: '';
	const timezoneOffset = timezone ? moment.tz(timezone).format('Z') : '';

	return (
		<Grid item spacing={2} xs={12} sm={4}>
			<Box sx={{ p: 'var(--pixel16)', bgcolor, borderRadius: 'var(--pixel13)', color: 'var(--whiteColor)' }}>
				<Stack direction='row' spacing={1}>
					<Typography><IoCalendarOutline/></Typography>
					<Typography variant='body2'>
						{formattedDate}
					</Typography>
				</Stack>
				<Typography variant='h5'>
					{formattedTime} {timezoneOffset} - {timezoneName}
				</Typography>
				<Typography variant='body2'>
					{timezone}
				</Typography>
			</Box>
		</Grid>
	);
};

export default React.memo(TimeCards);